import { limit as limitFirebase, orderBy, where } from "firebase/firestore"
import { getRevenda, getUsuario } from '../../config/auth'
import { Collection, WhereField } from '../../shared/constants'
import { documentMask, isNullOrEmpty, normalizedField } from '../../shared/utils'
import { addDoc, getAllDocs, getAllDocsByQueries, getAllDocsByRevendaId, getCountByQueries, getDocById, updateDoc } from './collectionBaseWorker'

export const addCliente = async ({ nome, email, representante, phone, document, address, revendaId, welcomeEmail, slots, dealer }) => {
    var data = {
        nome: nome,
        razaoSocial: nome,
        celular: phone,
        documento: documentMask(document),
        email: email,
        createdAt: new Date(),
        createdBy: email,
        representante: representante,
        revendaId: revendaId ?? getRevenda()?.id,
        habilitarEnviarCobrancaPorWhatsApp: true,
        habilitarEnviarCobrancaPorEmail: true,
        habilitarEmissaoDeNotaFiscal: true,
        welcomeEmail: welcomeEmail ?? true,
        habilitarEstabelecimentoPagamente: false,
        platform: "site",
        dealer: dealer,
        slots: parseInt(slots ?? 0),
        endereco: {
            cep: address?.cep,
            logradouro: address?.logradouro ?? "Endereço de exemplo",
            numero: address?.numero ?? "123",
            bairro: address?.bairro,
            cidade: address?.cidade,
            estado: address?.estado,
            ibge: address?.ibge,
            complemento: address?.complemento
        },
        status: "Ativo",
        leadStatus: "aguardando",
        tipoDocumento: normalizedField(document).length === 11 ? "CPF" : "CNPJ"
    }
    const doc = await addDoc({ collection: Collection.CLIENT, data: data })
    return doc.id;
}

export const getClientById = async ({ id }) => {
    return await getDocById({ collection: Collection.CLIENT, id: id })
}

export const getAllClientsByRevendaIdsAndDate = async ({ revendaIds, startDate, endDate }) => {
    const items = await getAllDocsByQueries({
        collection: Collection.CLIENT,
        queries: [
            where(WhereField.REVENDAID, "in", revendaIds),
            where(WhereField.CREATED_AT, ">=", startDate),
            where(WhereField.CREATED_AT, "<=", endDate),
            orderBy(WhereField.CREATED_AT, "desc"),
        ]
    })
    return items.filter(e => e.status !== "Inativo")
}

export const countClientByReseleId = async ({ revendaId }) => {
    const quantity = await getCountByQueries({
        collection: Collection.CLIENT,
        queries: [
            where(WhereField.REVENDAID, "==", revendaId),
        ]
    })
    return quantity
}

export const getAllClientsByRevendaId = async ({ revendaId }) => {
    const items = await getAllDocsByRevendaId({ collection: Collection.CLIENT, revendaId: revendaId })
    items.map(e => {
        return {
            habilitarEnviarCobrancaPorWhatsApp: true,
            habilitarEnviarCobrancaPorEmail: true,
            habilitarEmissaoDeNotaFiscal: true,
            ...e
        }
    })
    return items
}

export const getAllClients = async () => {
    const items = await getAllDocs({ collection: Collection.CLIENT })
    return items.map(e => {
        return {
            habilitarEnviarCobrancaPorWhatsApp: true,
            habilitarEnviarCobrancaPorEmail: true,
            habilitarEmissaoDeNotaFiscal: true,
            ...e
        }
    })
}

export const getAllClientsByLimit = async ({ limit, revendaId, leadStatus }) => {
    const result = await getAllDocsByQueries({
        collection: Collection.CLIENT,
        queries: [
            where(WhereField.REVENDAID, "==", revendaId),
            !isNullOrEmpty(leadStatus) && where(WhereField.LEAD_STATUS, "==", leadStatus),
            orderBy(WhereField.CREATED_AT, "desc"),
            limitFirebase(limit ?? 50)
        ]
    })
    return result.filter(e => e.status !== "Inativo")
}

export const getAllClientsByRevendaIdAndStatus = async ({ status, revendaId }) => {
    return await getAllDocsByQueries({
        collection: Collection.CLIENT,
        queries: [
            where(WhereField.STATUS, "==", status),
            where(WhereField.REVENDAID, "==", revendaId)
        ]
    })
}

export const getAllClientsByStatus = async ({ status }) => {
    return await getAllDocsByQueries({
        collection: Collection.CLIENT,
        queries: [
            where(WhereField.STATUS, "==", status)
        ]
    })
}

export const getAllClientsByRevendedorId = async ({ revendedorId }) => {
    return await getAllDocsByQueries({
        collection: Collection.CLIENT,
        queries: [
            where(WhereField.REVENDEDOR__ID, "==", revendedorId)
        ]
    })
}

export const getAllClientsBySupportId = async ({ supportId }) => {
    return await getAllDocsByQueries({
        collection: Collection.CLIENT,
        queries: [
            where(WhereField.SUPPORT__ID, "==", supportId)
        ]
    })
}

export const updateClientRevendaId = async ({ id, revendaId }) => {
    await updateDoc({
        collection: Collection.CLIENT, id: id, data: {
            revendaId: revendaId,
            changeRevendaBy: getUsuario()?.nome,
            changeRevendaAt: new Date(),
            revendedorAssociatedAt: null,
            revendedor: null
        }
    })
}

export const setClientUserToReseller = async ({ id, user }) => {
    await updateDoc({
        collection: Collection.CLIENT,
        id: id,
        data: {
            revendedorAssociatedAt: new Date(), revendedor: user
        }
    })
}

export const updateClientStatus = async ({ id, status }) => {
    await updateDoc({ collection: Collection.CLIENT, id: id, data: { status: status } })
}

export const updateClientById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.CLIENT, id: id, data: data })
}